module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-minus-fill-859e0537.svg";